module.exports = __webpack_public_path__ + "static/media/post-03.fe3f69be.png";